// src/features/dashboard/utils/dashboardHelpers.ts

import { DealListItem, ProjectListItem, ProjectCase, Customer, ProjectRequestListItem } from '../../../types';
import { DashboardStats } from '../types';

// Calculate statistics from raw data arrays
export function calculateDashboardStats(
  projectRequests: ProjectRequestListItem[],
  deals: DealListItem[],
  projects: ProjectListItem[],
  cases: ProjectCase[],
  customers: Customer[]
): DashboardStats {
  const dealsByStage: Record<string, number> = {};
  deals.forEach((deal) => {
    dealsByStage[deal.stage] = (dealsByStage[deal.stage] || 0) + 1;
  });

  return {
    projectRequests: {
      total: projectRequests.length,
      pending: projectRequests.filter((pr) => !pr.deal_id).length,
      converted: projectRequests.filter((pr) => pr.deal_id).length,
    },
    deals: {
      total: deals.length,
      byStage: dealsByStage,
      closedWon: deals.filter((d) => d.stage === 'Closed Won').length,
      closedLost: deals.filter(
        (d) => d.stage === 'Closed Lost' || d.stage === 'Closed Lost to Competition'
      ).length,
    },
    projects: {
      total: projects.length,
      active: projects.filter(
        (p) => p.status === 'Active' || p.status === 'In Progress' || p.status === 'On Track'
      ).length,
      completed: projects.filter((p) => p.status === 'Completed').length,
    },
    cases: {
      total: cases.length,
      open: cases.filter((c) => c.case_status === 'ready' || c.case_status === 'in_progress').length,
      resolved: cases.filter((c) => c.case_status === 'resolved').length,
    },
    customers: {
      total: customers.length,
      active: customers.filter((c) => c.status === 'active').length,
    },
    tasks: {
      total: 0,
      inProgress: 0,
      completed: 0,
    },
  };
}

// Get CSS classes for deal stage badges (legacy — use Badge + dealStageVariant instead)
export function getStageColor(stage: string): string {
  if (stage === 'Closed Won') return 'bg-green-600 text-white';
  if (stage === 'Closed Lost' || stage === 'Closed Lost to Competition') return 'bg-red-600 text-white';
  if (stage === 'Negotiation/Review') return 'bg-blue-600 text-white';
  return 'bg-yellow-500 text-white';
}

// Get CSS classes for status badges (legacy — use Badge + projectStatusVariant instead)
export function getStatusColor(status: string): string {
  if (status === 'Completed' || status === 'resolved') return 'bg-green-600 text-white';
  if (status === 'Active' || status === 'In Progress' || status === 'in_progress') return 'bg-blue-600 text-white';
  if (status === 'Delayed') return 'bg-red-600 text-white';
  return 'bg-gray-500 text-white';
}
